<ul class="navbar-nav me-auto">
  <li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle d-flex align-items-center" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span class="e-icons icon-earth--filled"></span>
    </a>
    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
      @for (item of languages; track item) {
        <a [class]="addClass(item)" (click)="setLanguage(item)">{{item}}</a>
      }
    </div>
  </li>
</ul>
